export default __webpack_public_path__ + "static/media/modelimg2.c3ecf26e.png";